export const getters = {
  getTiles: state => (orgId) => state.tiles[orgId] || [],

  getArrangement: state => (orgId) => state.arrangement[orgId] || 'lr',

  getDividers: state => (orgId) => state.dividers[orgId] || { x: 0.5, y: 0.5 },

  isSplitActive: state => (orgId) => (state.tiles[orgId] || []).length > 1,

  // A map is visible iff it's currently a tile.
  isVisible: state => (orgId, mapId) => (state.tiles[orgId] || []).includes(mapId),

  isInitialized: state => (orgId) => state.initialized[orgId] === true,

  // Default true when unset so newly-added tiles start synced.
  isSyncEnabled: state => (mapId) => state.syncEnabled[mapId] !== false,

  getFocusedTile: state => state.focusedTile,
}
